import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import {TranslatedNames} from "./translated-names.model";

export class Desk {

    active: boolean;
    capacity: number;
    canAskCustomerName: boolean;
    canPrint: boolean;
    centerInternalId: string;
    centerName: string;
    countAutoReset: boolean;
    creationDate: number;
    currentTurn: string;
    dailyReset: boolean;
    deskName: string;
    deskPrefix: string;
    devicesBound: Array<DeviceBasic>;
    image: string;
    imageL: string;
    imageM: string;
    imageS: string;
    imageXl: string;
    initialCount: number;
    internalId: string;
    limitCount: number;
    locationsBound: Array<Location>;
    modificationDate: number;
    nextTurn: string;
    notifyPrevious: boolean;
    notifyLast: boolean;
    smsInternalId: string;
    smsNotifyDesk: boolean;
    ticketInternalId: string;
    turnTypeInternalId: string;
    voiceActivate: boolean;
    voicePrefix: boolean;
    showTurnsAtTotem: boolean;
    availableTurn: boolean;
    autoAdvance: boolean;
    dataType: boolean;
    hasVip: boolean;
    translatedNames: Array<TranslatedNames>;

    constructor(active?: boolean, capacity?: number, canAskCustomerName?: boolean, canPrint?: boolean, centerInternalId?: string, centerName?: string, countAutoReset?: boolean, creationDate?: number, currentTurn?: string, dailyReset?: boolean, deskName?: string, deskPrefix?: string, devicesBound?: Array<DeviceBasic>, image?: string, imageS?: string, imageL?: string, imageM?: string, imageXl?: string, initialCount?: number, internalId?: string, limitCount?: number, locationsBound?: Array<Location>, modificationDate?: number, nextTurn?: string, notifyPrevious?: boolean, notifyLast?: boolean, smsInternalId?: string, smsNotifyDesk?: boolean, ticketInternalId?: string, turnTypeInternalId?: string, voiceActivate?: boolean, voicePrefix?: boolean, showTurnsAtTotem?: boolean, availableTurn?: boolean, autoAdvance?: boolean, dataType?: boolean, hasVip?: boolean, translatedNames?: Array<TranslatedNames>) {
            this.active = active;
            this.capacity = capacity;
            this.canAskCustomerName = canAskCustomerName;
            this.canPrint = canPrint;
            this.centerInternalId = centerInternalId;
            this.centerName = centerName;
            this.countAutoReset = countAutoReset;
            this.creationDate = creationDate;
            this.currentTurn = currentTurn;
            this.dailyReset = dailyReset;
            this.deskName = deskName;
            this.deskPrefix = deskPrefix;
            this.devicesBound = devicesBound;
            this.image = image;
            this.imageS = imageS;
            this.imageL = imageL;
            this.imageM = imageM;
            this.imageXl = imageXl;
            this.initialCount = initialCount;
            this.internalId = internalId;
            this.limitCount = limitCount;
            this.locationsBound = locationsBound;
            this.modificationDate = modificationDate;
            this.nextTurn = nextTurn;
            this.notifyPrevious = notifyPrevious;
            this.notifyLast = notifyLast;
            this.smsInternalId = smsInternalId;
            this.smsNotifyDesk = smsNotifyDesk;
            this.ticketInternalId = ticketInternalId;
            this.turnTypeInternalId = turnTypeInternalId;
            this.voiceActivate = voiceActivate;
            this.voicePrefix = voicePrefix;
            this.showTurnsAtTotem = showTurnsAtTotem;
            this.availableTurn = availableTurn;
            this.autoAdvance = autoAdvance;
            this.dataType = dataType;
            this.hasVip = hasVip;
            this.translatedNames = translatedNames;
    }

    public get Active() {
        return this.active;
    }
    public get CanAskCustomerName() {
        return this.canAskCustomerName;
    }
    public get Capacity() {
        return this.capacity;
    }
    public get CanPrint() {
        return this.canPrint;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get CountAutoReset() {
        return this.countAutoReset;
    }
    public get CreationDate() {
        return this.creationDate;
    }
    public get CurrentTurn() {
        return this.currentTurn;
    }
    public get DailyReset() {
        return this.dailyReset;
    }
    public get DeskName() {
        return this.deskName;
    }
    public get DeskPrefix() {
        return this.deskPrefix;
    }
    public get DevicesBound() {
        return this.devicesBound;
    }
    public get Image() {
        return this.image;
    }
    public get ImageS() {
        return this.imageS;
    }
    public get ImageL() {
        return this.imageL;
    }
    public get ImageM() {
        return this.imageM;
    }
    public get ImageXl() {
        return this.imageXl;
    }
    public get InitialCount() {
        return this.initialCount;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get LimitCount() {
        return this.limitCount;
    }
    public get LocationsBound() {
        return this.locationsBound;
    }
    public get ModificationDate() {
        return this.modificationDate;
    }
    public get NextTurn() {
        return this.nextTurn;
    }
    public get NotifyPrevious() {
        return this.notifyPrevious;
    }
    public get NotifyLast() {
        return this.notifyLast;
    }
    public get SmsInternalId() {
        return this.smsInternalId;
    }
    public get SmsNotifyDesk() {
        return this.smsNotifyDesk;
    }
    public get TicketInternalId() {
        return this.ticketInternalId;
    }
    public get TurnTypeInternalId() {
        return this.turnTypeInternalId;
    }
    public get VoiceActivate() {
        return this.voiceActivate;
    }
    public get VoicePrefix() {
        return this.voicePrefix;
    }
    public get ShowTurnsAtTotem() {
        return this.showTurnsAtTotem;
    }
    public get AvailableTurn() {
        return this.availableTurn;
    }
    public get AutoAdvance() {
        return this.autoAdvance;
    }
    public get DataType() {
        return this.dataType;
    }
    public get HasVip() {
        return this.hasVip;
    }
    public get TranslatedNames() {
      return this.translatedNames;
    }
    public set Active(active) {
        this.active = active;
    }
    public set CanAskCustomerName(canAskCustomerName) {
        this.canAskCustomerName = canAskCustomerName;
    }
    public set CanPrint(canPrint) {
        this.canPrint = canPrint;
    }
    public set Capacity(capacity) {
        this.capacity = capacity;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set CountAutoReset(countAutoReset: boolean) {
        this.countAutoReset = countAutoReset;
    }
    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }
    public set CurrentTurn(currentTurn) {
        this.currentTurn = currentTurn;
    }
    public set DailyReset(dailyReset) {
        this.dailyReset = dailyReset;
    }
    public set DeskName(deskName) {
        this.deskName = deskName;
    }
    public set DeskPrefix(deskPrefix) {
        this.deskPrefix = deskPrefix;
    }
    public set DevicesBound(devicesBound) {
        this.devicesBound = devicesBound;
    }
    public set Image(image) {
        this.image = image;
    }
    public set ImageS(imageS) {
        this.imageS = imageS;
    }
    public set ImageL(imageL) {
        this.imageL = imageL;
    }
    public set ImageM(imageM) {
        this.imageM = imageM;
    }
    public set ImageXl(imageXl) {
        this.imageXl = imageXl;
    }
    public set InitialCount(initialCount) {
        this.initialCount = initialCount;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set LimitCount(limitCount) {
        this.limitCount = limitCount;
    }
    public set LocationsBound(locationsBound) {
        this.locationsBound = locationsBound;
    }
    public set ModificationDate(modificationDate) {
        this.modificationDate = modificationDate;
    }
    public set NextTurn(nextTurn) {
        this.nextTurn = nextTurn;
    }
    public set NotifyPrevious(notifyPrevious) {
        this.notifyPrevious = notifyPrevious;
    }
    public set NotifyLast(notifyLast) {
        this.notifyLast = notifyLast;
    }
    public set SmsInternalId(smsInternalId) {
        this.smsInternalId = smsInternalId;
    }
    public set SmsNotifyDesk(smsNotifyDesk) {
        this.smsNotifyDesk = smsNotifyDesk;
    }
    public set TicketInternalId(ticketInternalId) {
        this.ticketInternalId = ticketInternalId;
    }
    public set TurnTypeInternalId(turnTypeInternalId) {
        this.turnTypeInternalId = turnTypeInternalId;
    }
    public set VoiceActivate(voiceActivate) {
        this.voiceActivate = voiceActivate;
    }
    public set VoicePrefix(voicePrefix) {
        this.voicePrefix = voicePrefix;
    }
    public set ShowTurnsAtTotem(showTurnsAtTotem) {
        this.showTurnsAtTotem = showTurnsAtTotem;
    }
    public set AvailableTurn(availableTurn) {
        this.availableTurn = availableTurn;
    }
    public set AutoAdvance(autoAdvance) {
        this.autoAdvance = autoAdvance;
    }
    public set DataType(dataType) {
        this.dataType = dataType;
    }
    public set HasVip(hasVip) {
        this.hasVip = hasVip;
    }
    public set TranslatedNames(translatedNames) {
      this.translatedNames = translatedNames;
    }
}
